import axios from "axios";
import { UrlBundles, UserInfo } from "Libs/core";
import _ from "lodash";
import * as a from "../types/actions.types";
import * as g from "../types/getters.types";
import * as m from "../types/mutations.types";
import moment from "moment";

const riders = {
  namespaced: true,
  state: {
    riderAvailabilityList: [],
    riderAvailabilityMap: {},
  },
  getters: {
    [g.GET_RIDER_AVAILABILITY_LIST](state) {
      return state.riderAvailabilityList;
    },
    [g.GET_RIDER_AVAILABILITY_MAP](state) {
      return state.riderAvailabilityMap;
    },
  },
  mutations: {
    [m.SET_RIDER_AVAILABILITY](state, payload) {
      state.riderAvailabilityList = payload.list;
      state.riderAvailabilityMap = payload.map;
    },
  },
  actions: {
    [a.SAVE_RIDER_AVAILABILITY]({}, payload) {
      let promises = [];
      payload.map((slot) => {
        let promise = axios.post(UrlBundles.ridersAvailabilityApi, {
          fromDate: slot.fromDate,
          toDate: slot.toDate,
        });
        promises.push(promise);
      });

      return Promise.all(promises);
    },
    [a.LOAD_RIDER_AVAILABILITY]({ commit }) {
      return axios.get(UrlBundles.ridersAvailabilityApi).then((res) => {
        let riderAvailabilityMap = (
          (res.data || []).sort(function(a, b) {
            return new Date(a.fromDate).getTime() - new Date(b.fromDate).getTime(); // Ascending order
          }) || []
        ).reduce(function(r, el) {
          let dateString = moment
            .utc(el.fromDate)
            .local()
            .format("YYYY-MM-DD");
          el._day = dateString;
          let todayString = moment
            .utc()
            .local()
            .format("YYYY-MM-DD");

          r[dateString] = r[dateString] || [];
          r[dateString].push(el);
          dateString === todayString ? (r[dateString]._isToday = true) : (r[dateString]._isToday = false);

          return r;
        }, {});

        commit(m.SET_RIDER_AVAILABILITY, {
          list: res.data || [],
          map: riderAvailabilityMap || [],
        });
      });
    },
    [a.DELETE_RIDER_AVAILABILITY]({ commit }, availabilityId) {
      return axios.delete(UrlBundles.ridersAvailabilityApi + "/" + availabilityId);
    },
  },
};

export default riders;
